import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { TASK_COMPLETION_SLICES, QUICK_LINK_TYPES } from '../../../constants/constants';
import './TaskCompletion.scss';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Graph100StackedBar from '../../Common/Graph100StackedBar';
import { Routes } from '../../../constants/routes';
import { NavigateToRouteWithDashboardParams, NavigateToRouteWithTaskCompletionParams } from '../../../helpers/routing';
import BarCard from '../../Common/BarCard/BarCard';
import Icon from '../../Common/Icon';
import { Menu } from 'primereact/menu';

class TaskCompletion extends React.Component {

    constructor(props, context) {
        super(props, context);

        const slices = [
            { id: TASK_COMPLETION_SLICES.Discipline, name: TASK_COMPLETION_SLICES.Discipline },
            { id: TASK_COMPLETION_SLICES.Department, name: TASK_COMPLETION_SLICES.Department },
            { id: TASK_COMPLETION_SLICES.Responsible, name: TASK_COMPLETION_SLICES.Responsible },
            { id: TASK_COMPLETION_SLICES.Phase, name: TASK_COMPLETION_SLICES.Phase },
            { id: TASK_COMPLETION_SLICES.Community, name: TASK_COMPLETION_SLICES.Community },
            { id: TASK_COMPLETION_SLICES.Tag, name: TASK_COMPLETION_SLICES.Tag },
        ]
        this.state = {
            slices: slices,
            selectedSliceName: slices[0].id,
            cards: [],
            userKey: '',
            isLoading: false
        }
    }

    componentDidMount = async () => {
        await this.loadSection();
    }

    componentDidUpdate(prevProps) {
        if (this.props.locationKey && this.props.locationKey !== prevProps.locationKey) {
            this.loadSection();
        }
    }

    loadSection = async () => {
        try {
            this.setState({ isLoading: true });
            const response = await this.props.locationDashboardActions.loadTaskCompletionBySection(this.props.subscriptionId, this.props.locationKey, this.state.selectedSliceName);
            if (response.type === types.LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_SUCCESS) {
                this.setState({ 
                    cards: response.payload.cards,
                    userKey: response.payload.userKey
                });
            } else if (response.type === types.LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onSliceChange = (sliceName) => {
        this.setState({ selectedSliceName: sliceName }, this.loadSection);
    }

    onCardNameClick = (card) => {
        NavigateToRouteWithDashboardParams(Routes.Tasks, card.urlParams, false);
    }

    onQuickLinkClick = (urlParams) => {
        NavigateToRouteWithDashboardParams(Routes.Tasks, urlParams, false);
    }

    onHundyPBarClick = (dataPoint) => {
        NavigateToRouteWithDashboardParams(Routes.Tasks, dataPoint.urlParams, false);
    }

    onShareDisipline = () => {

        const urlParams = {
            LocationKey: [this.props.locationKey],
            UserKey: [this.state.userKey],
            SliceName: [TASK_COMPLETION_SLICES.Discipline]
        };
        NavigateToRouteWithTaskCompletionParams(Routes.External.TaskCompletion, urlParams);
    }

    onCogClick = (e) => {
        this.menu.toggle(e);
    }

    render() {

        const menuOptions = [
            { label: "Share Graph", value: "shareGraph", command: this.onShareDisipline }
        ];

        return (
            <div className="task-completion-section">
                <div className="row">
                    <div className="col-xs-12 col-md-4 col-lg-3 dashboard-widget-title">Task Completion By:</div>
                    <div className="col-xs-10 col-md-4 col-lg-3">
                        <MultiSelectBox
                            name="slides"
                            idField="id"
                            valueField="name"
                            options={this.state.slices}
                            isMulti={false}
                            onChange={this.onSliceChange}
                            selectedValues={this.state.selectedSliceName.toString()}
                        />
                    </div>
                    {
                        this.state.selectedSliceName === TASK_COMPLETION_SLICES.Discipline &&
                            <div className="col-xs-2 col-md-4 col-lg-6">
                                <div className="cog" alt="Options" onClick={this.onCogClick}><Icon name="cog" /></div>
                            </div>
                    }
                </div>
                <Menu model={menuOptions} popup={true} ref={el => this.menu = el} />
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="row mt-2">
                        <div className="col-12">
                    {

                        this.state.cards && this.state.cards.length
                        ?
                            this.state.cards.map(card => {
                                return (
                                    <div key={card.id}>
                                        <BarCard backgroundColor="white">
                                            <div className="container-fluid slice-content">
                                                <div className="row mt-2">
                                                    <div className="col-md-4">
                                                        <div className="job-content">
                                                            <div className="name" onClick={() => this.onCardNameClick(card)}>{card.name}</div>
                                                            <div className="job-title">{card.jobTitle}</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <Graph100StackedBar data={card.graphData} onClick={this.onHundyPBarClick} />
                                                    </div>
                                                    {!this.props.isMobile &&
                                                        <div className="col-md-4">
                                                            <div className="quick-links">
                                                                <div className="quick-links-container">
                                                                {
                                                                    card.quickLinks.map((link, index, quickLinks) => {
                                                                        // Only put a divider between the quick links, not after all of them
                                                                        let quickLinkClass = (index+1 === quickLinks.length) ? "quick-link" : "quick-link divider";
                                                                        let clickHandler = this.onQuickLinkClick;
                                                                        if (link.total > 0) {
                                                                            quickLinkClass += " clickable";
                                                                        } else {
                                                                            // If a quick link has a total of zero, then don't bother making it clickable.
                                                                            // and provide a noop click handler
                                                                            clickHandler = () => { /*Do nothing*/ };
                                                                        }

                                                                        const uiLink = QUICK_LINK_TYPES[link.type];
                                                                        if (!uiLink) {
                                                                            Notification("error", "Error", `Unsupported Quick Link Type found ${link.type}`);
                                                                            return;
                                                                        }
                                                                        const title = uiLink.title;
                                                                        const color = uiLink.color;

                                                                        return (
                                                                            <div key={link.type} className={quickLinkClass} onClick={() => clickHandler(link.urlParams)}>
                                                                                <span className="total" style={{ color: color}}>{link.total}</span>
                                                                                <span className="title">{title}</span>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                                </div>
                                                            </div>                                                    
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </BarCard>
                                    </div>
                                )
                            })                         
                        :
                            <div>No Tasks Found</div>
                    }
                        </div>
                    </div>
                </LoadingIndicator>
            </div>
        );
    }
}

TaskCompletion.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    locationKey: PropTypes.string.isRequired,
    locationDashboardActions: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired
};

export default TaskCompletion;
